import React from 'react';
import { NavLink } from 'react-router-dom';

const navItems = [
 { label: 'Home', to: '/' },
 { label: 'Shop', to: '/shop' },
 { label: 'Articles', to: '/articles' },
 { label: 'About', to: '/#about' },
 { label: 'Contact', to: '/#contact' },
];

function CartIcon() {
 return (
  <NavLink to="/shop" aria-label="Go to shop" className="cart-link">
   <span className="cart-mark" aria-hidden="true">⌁</span>
   <span className="cart-count">0</span>
  </NavLink>
 );
}

export default function Navbar({ theme = 'dark' }) {
 const dark = theme === 'dark';

 return (
  <>
   <header className={`flyshit-site-header ${dark ? 'flyshit-site-header--dark' : 'flyshit-site-header--light'}`}>
    <div className="flyshit-site-header__inner">
     <NavLink to="/" aria-label="Flyshit NYC home" className="flyshit-site-wordmark">
      FLY$HITNYC
     </NavLink>

     <nav className="flyshit-site-nav" aria-label="Primary navigation">
      {navItems.map((item) => {
       const isHashLink = item.to.includes('#');
       if (isHashLink) {
        return (
         <a key={item.to} href={item.to} className="flyshit-site-nav__link">
          {item.label}
         </a>
        );
       }

       return (
        <NavLink
         key={item.to}
         to={item.to}
         end={item.to === '/'}
         className={({ isActive }) => `flyshit-site-nav__link${isActive ? ' flyshit-site-nav__link--active' : ''}`}
        >
         {item.label}
        </NavLink>
       );
      })}
     </nav>

     <div className="flyshit-site-actions">
      <CartIcon />
     </div>
    </div>
   </header>
   <div aria-hidden="true" className="flyshit-site-header-spacer" />
  </>
 );
}
